export default __webpack_public_path__ + "48c611c9f2d4240d011a3167dfe84bcb.png";